import { Type } from '@angular/core';

import { OptionALayoutComponent } from './core/layouts/option-a/option-a-layout.component';
import { OptionBLayoutComponent } from './core/layouts/option-b/option-b-layout.component';
import { OptionCLayoutComponent } from './core/layouts/option-c/option-c-layout.component';
import { OptionDLayoutComponent } from './core/layouts/option-d/option-d-layout.component';
import { MobileLayoutComponent } from './core/layouts/mobile/mobile-layout.component';
import { ClarityLayoutComponent } from './core/layouts/clarity-layout/clarity-layout.component';
import { SandStormLayoutComponent } from './core/layouts/sand-storm-layout/sand-storm-layout.component';
import { TeamsLayoutComponent } from './core/layouts/teams-layout/teams-layout.component';
import { BetaLayoutComponent } from './core/layouts/beta-layout/beta-layout.component';
interface IAppLayout {
  name: string;
  component: Type<any>;
}

const availableLayouts: Array<IAppLayout> = [
  {
    name: 'A',
    component: OptionALayoutComponent
  },
  {
    name: 'B',
    component: OptionBLayoutComponent
  },
  {
    name: 'C',
    component: OptionCLayoutComponent
  },
  {
    name: 'D',
    component: OptionDLayoutComponent
  },
  {
    name: 'mobile',
    component: MobileLayoutComponent
  }, {
    name: 'clarity',
    component: ClarityLayoutComponent
  }, {
    name: 'multi-ai',
    component: SandStormLayoutComponent
  },
  {
    name: 'teams',
    component: TeamsLayoutComponent
  },
  {
    name: 'beta',
    component: BetaLayoutComponent
  }
];

// Select the default layout
const defaultLayout: IAppLayout = availableLayouts.find((layout: IAppLayout) => {
  // return layout.name === 'B';
  // return layout.name === 'mobile';
  // return layout.name === 'clarity';
  return layout.name === 'beta';
  // return layout.name === 'multi-ai';
});

export { IAppLayout, availableLayouts, defaultLayout };
